import React, { FC, ReactNode } from 'react';
import { Label as DefaultLabel } from 'semantic-ui-react';
import classnames from 'classnames';

type Props = {
  classNames?: string | string[];
  children?: ReactNode;
};

export const Label: FC<Props> = ({ classNames, children }) => {
  return (
    <DefaultLabel
      className={classnames(classNames)}
      basic={true}
      color="orange"
      pointing="above"
      size="large"
    >
      {children}
    </DefaultLabel>
  );
};
